'use strict';

var RegionSelector = new Class({
	Implements: [Options, Events],

	options: {
		style: 'light',
		dispose_on_click: false,
		follow_url: true
	},

	initialize: function initialize(_element, options) {
		if (!_element) return;

		this._element = _element;
		this.setOptions(options);
		this.build();
	},

	build: function build() {
		var self = this;
		var opts = this.options;
		var _map = this._element.getElement('.map') || new Element('.map').inject(this._element);

		this.map = new RegionsMap(_map, opts);

		this.map.addEvent('mapReady', function () {
			self.draw();
		});
	},

	draw: function draw() {
		var self = this;
		var map = this.map;
		var map_message = this._element.getElement('.map_message');

		this.fx_msg = new Fx.Morph(map_message);

		google.maps.event.addListener(map.map, 'center_changed', function () {
			if (map_message) self.hide_message(map_message);
		});

		google.maps.event.addListener(map.map, 'zoom_changed', this.hide_message);

		this.set_hoods();
	},

	hide_message: function hide_message(msg) {
		if (!this.fx_msg) return;

		this.fx_msg.start({
			opacity: 0
		}).chain(function () {
			msg.dispose();
		});

		this.fx_msg = null;
	},

	select_hood: function select_hood(selected, data) {
		if (this.options.dispose_on_click) {
			this._element.dispose();
		}

		this.fireEvent('hoodSelect', [selected, data]);

		var url = data.url;

		if (this.options.follow_url && url) {
			window.location = url;
		}
	},

	set_hoods: function set_hoods() {
		var _bounds = this._element.getElement('.hoods_bounds');
		if (!_bounds) return;

		var bounds;

		try {
			bounds = JSONMOO.decode(_bounds.get('html'), false);
		} catch (e) {
			return;
		}

		if (typeOf(bounds) == 'object') {
			Object.each(bounds, function (el) {
				if (el.active != false) {
					this.map.set_region(el.name, el.bounds, this.select_hood.bind(this, null, el), false, el);
				}
			}.bind(this));
		} else if (typeOf(bounds) == 'array') {
			bounds.each(function (el) {
				if (el.active != false) {
					this.map.set_region(el.name, el.bounds, this.select_hood.bind(this, null, el), false, el);
				}
			}.bind(this));
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
Page.Nbh = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		var _nh_map = document.getElement('.w_neighborhoods_map');

		new RegionSelector(_nh_map, {
			lat: 40.74796,
			lng: -73.97,
			zoom: 12,
			max_zoom: 13,
			min_zoom: 11,
			zoom_control: true
		});
	}
});
//# sourceMappingURL=nbh.js.map
